export const channelNameIsValid = (channelName, availableChannels) => {
    return availableChannels.includes(channelName)
}

export default channelNameIsValid
